// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GlsA","col":"styles_col__1krhB","actions":"styles_actions__1fLvG","conflict":"styles_conflict__2eZam"};